import { DEFAULT_LANGUAGE, LANGUAGES } from 'config';
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';
import uk from "./translate/uk.json";
import ru from "./translate/ru.json";
import en from "./translate/en.json";
import ukSys from "./sys/uk.json";
import ruSys from "./sys/ru.json";
import enSys from "./sys/en.json";

class _InitLang {
  private localStorageKey = 'initLang';

  get initLang():string|null {
    return localStorage.getItem(this.localStorageKey);
  }
  set initLang(value:string|null) {
    if(value === null){
      localStorage.removeItem(this.localStorageKey);
    }else{
      localStorage.setItem(this.localStorageKey, value);
    }
  }

  get detectionOrder():string[] {
    if(this.initLang === null){
      return ['navigator']
    }else{
      return ['localStorage', 'navigator']
    }
  }
}
export const InitLang = new _InitLang()

i18n.on('languageChanging', function(lang) {
  if(lang !== undefined){
    InitLang.initLang = lang;
  }
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: undefined,
    supportedLngs: LANGUAGES.map((l) => l.code),
    detection: { order: InitLang.detectionOrder },
    resources: {
      uk: {
        translations: uk,
        sys: ukSys,
      },
      ru: {
        translations: ru,
        sys: ruSys,
      },
      en: {
        translations: en,
        sys: enSys,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    ns: ['translations', 'sys'],
    defaultNS: 'translations',
    debug: false,
    keySeparator: false,
    react: {
      // wait: true,
    }
  })

export default i18n